import { N0, N900 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { type Color } from './types';

const colorWhite = token('color.text.inverse', N0);
const colorBlack = token('color.text.accent.gray.bolder', N900);

const colors: Color[] = [
	{
		backgroundColor: token('color.background.accent.green.subtle', '#4BCE97'),
		color: colorBlack,
	},
	{
		backgroundColor: token('color.background.accent.orange.bolder', '#B65C02'),
		color: colorWhite,
	},
	{
		backgroundColor: token('color.background.accent.purple.subtle', '#9F8FEF'),
		color: colorBlack,
	},
	{
		backgroundColor: token('color.background.accent.teal.bolder', '#1D7F8C'),
		color: colorWhite,
	},
	{
		backgroundColor: token('color.background.accent.red.subtle', '#F87462'),
		color: colorBlack,
	},
	{
		backgroundColor: token('color.background.accent.yellow.bolder', '#946F00'),
		color: colorWhite,
	},
	{
		backgroundColor: token('color.background.accent.teal.subtle', '#60C6D2'),
		color: colorBlack,
	},
	{
		backgroundColor: token('color.background.accent.magenta.bolder', '#AE4787'),
		color: colorWhite,
	},
	{
		backgroundColor: token('color.background.accent.yellow.subtle', '#E2B203'),
		color: colorBlack,
	},
	{
		backgroundColor: token('color.background.accent.red.bolder', '#CA3521'),
		color: colorWhite,
	},
	{
		backgroundColor: token('color.background.accent.orange.subtle', '#FAA53D'),
		color: colorBlack,
	},
	{
		backgroundColor: token('color.background.accent.green.bolder', '#1F845A'),
		color: colorWhite,
	},
	{
		backgroundColor: token('color.background.accent.magenta.subtle', '#E774BB'),
		color: colorBlack,
	},
];

export { colors };
